// extracted by mini-css-extract-plugin
module.exports = {"box_container":"styles_box_container__X1bZi","hide":"styles_hide__usYvk"};